import { render } from "./myprofileeditor.vue?vue&type=template&id=5d3f5d5f"
import script from "./myprofileeditor.vue?vue&type=script&lang=js"
export * from "./myprofileeditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__